/* eslint-disable react/jsx-no-useless-fragment */
import { Children, HTMLProps, PropsWithChildren, ReactNode } from 'react';

type ValueTypes = string | Date | number | null | undefined;

interface ValueOrNDashProps<T extends ValueTypes> extends PropsWithChildren {
    value?: T;
    dashProps?: HTMLProps<HTMLSpanElement>;
    strictEqual?: boolean;
    valueRender?: (value: NonNullable<T>) => ReactNode;
}

export const ValueOrNDash = <T extends ValueTypes>(props: ValueOrNDashProps<T>) => {
    const { strictEqual, valueRender, value, dashProps } = props;
    const hasValue = strictEqual ? value !== undefined && value !== null : !!value;

    if (!hasValue && Children.count(props.children) === 0) {
        return <span {...dashProps}>&ndash;</span>;
    }
    if (hasValue) {
        // hasValue can only be true if value has a value
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return valueRender ? valueRender(value!) : <>{value}</>;
    }
    return <>{props.children}</>;
};
